var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("callback-status", { attrs: { variant: "failed" } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }